import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Industries from './pages/Industries';
import Pricing from './pages/Pricing';
import FAQPage from './pages/FAQPage';
import Testimonials from './components/Testimonials';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { homeData } from './data/homeData';
import { aboutContent } from './data/aboutData';
import { servicesData } from './data/servicesData';
import { contactData } from './data/contactData';
import PageTemplate from './components/PageTemplate';
import ScrollToTop from './components/ScrollToTop';

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTemplate {...homeData.helmet}><Home /></PageTemplate>} />
        <Route path="/about-us" element={<PageTemplate {...aboutContent.helmet}><About /></PageTemplate>} />
        <Route path="/services" element={<PageTemplate {...servicesData.helmet}><Services /></PageTemplate>} />
        <Route
          path="/industries"
          element={
            <PageTemplate
              title="Industries We Serve — Cygnet Call Centre"
              description="Cygnet Call Centre serves 15+ industries including Healthcare, Trades, Legal, Estate Agents, Education, Automotive, Energy, Security, and Charities. Specialists in your sector's specific call handling needs."
              keywords="call centre for healthcare, call answering for trades, legal receptionist, estate agent answering service, school absence line, automotive booking line, charity helpline"
              ogUrl="https://www.cygnetcall.co.uk/industries"
            >
              <Industries />
            </PageTemplate>
          }
        />
        <Route
          path="/pricing"
          element={
            <PageTemplate
              title="Pricing — Cygnet Call Centre"
              description="Transparent, flexible call centre pricing tailored to your business. No setup fees, no long-term lock-in. Plans for sole traders through to enterprise. Same-day setup."
              keywords="call centre pricing, virtual receptionist cost, call answering service price UK"
              ogUrl="https://www.cygnetcall.co.uk/pricing"
            >
              <Pricing />
            </PageTemplate>
          }
        />
        <Route
          path="/faq"
          element={
            <PageTemplate
              title="Frequently Asked Questions — Cygnet Call Centre"
              description="Answers to common questions about Cygnet Call Centre's services, pricing, setup, and how we work. Same-day setup, no sales calls, 24/7 UK-based team."
              keywords="call centre FAQ, virtual receptionist questions, call handling setup"
              ogUrl="https://www.cygnetcall.co.uk/faq"
            >
              <FAQPage />
            </PageTemplate>
          }
        />
        <Route path="/testimonials" element={<PageTemplate><Testimonials /></PageTemplate>} />
        <Route path="/contact" element={<PageTemplate {...contactData.helmet}><Contact /></PageTemplate>} />
        <Route
          path="/privacy-policy"
          element={
            <PageTemplate
              title="Privacy Policy — Cygnet Call Centre"
              description="Cygnet Call Centre's privacy policy. How we collect, use and protect your personal data in accordance with UK GDPR."
              ogUrl="https://www.cygnetcall.co.uk/privacy-policy"
            >
              <PrivacyPolicy />
            </PageTemplate>
          }
        />
        <Route path="*" element={<PageTemplate title="Page Not Found - Cygnet Call Centre"><NotFound /></PageTemplate>} />
      </Routes>
    </AnimatePresence>
  );
};

const App = () => (
  <Router>
    <ScrollToTop />
    <AnimatedRoutes />
  </Router>
);

export default App;
